// env
const prodUrl = 'https://api.browniepoints.africa'
const quicksticksUrl = 'https://api.quicksticks.io'
const quicksticksStagingUrl = 'https://staging-api.quicksticks.io'
const dataFreeUrl = 'https://api.data-free.org.za'
const browzaFreeUrl = 'https://api.browzafree.org.za'
const stagingUrl = 'https://staging-api.browniepoints.africa'
const backendUrl = import.meta.env.VITE_BACKEND_URL
const env = import.meta.env.VITE_REDUX_ENV || import.meta.env.NODE_ENV

const getProductionUrl = () => {
  if (window.location.href.indexOf('sef-develop') > -1) {
    return stagingUrl
  }

  if (window.location.href.indexOf('staging.quicksticks.io') > -1) {
    return quicksticksStagingUrl
  }

  if (window.location.href.indexOf('quicksticks.io') > -1) {
    return quicksticksUrl
  }

  if (window.location.href.indexOf('data-free.org.za') > -1) {
    return dataFreeUrl
  }

  if (window.location.href.indexOf('browzafree.org.za') > -1) {
    return browzaFreeUrl
  }

  return prodUrl
}

function determineBaseUrl() {
  const productionUrl = getProductionUrl()

  switch (env) {
    case 'development':
      return backendUrl

    case 'staging':
      return stagingUrl

    case 'production':
      // hack for Netlify, otherwise it attempts to fetch prod DB for a staging ENV
      return productionUrl

    default:
      return backendUrl
  }
}

const baseUrl = determineBaseUrl()

export default baseUrl
